@if (errors) {
  <div class="ec-input-error">
    @if (errors.required) {
      <div>{{ errors.required.message ?? ('error.required' | translate) }}</div>
    }

    @if (errors.minlength) {
      <div>{{ (errors.message ?? 'error.minlength' | translate: { minlength: errors.minlength.requiredLength }) | replace: 'minlength' : errors.minlength.requiredLength }}</div>
    }

    @if (errors.maxlength) {
      <div>{{ (errors.message ?? 'error.maxlength' | translate: { maxlength: errors.maxlength.requiredLength }) | replace: 'maxlength' : errors.maxlength.requiredLength }}</div>
    }

    @if (errors.min) {
      <div>{{ (errors.message ?? ('error.min' | translate: { min: errors.min.min } )) | replace: 'min' : errors.min.min }}</div>
    }

    @if (errors.max) {
      <div>{{ (errors.message ?? 'error.max' | translate: { max: errors.max.max }) | replace: 'max' : errors.max.max }}</div>
    }

    @if (errors.email) {
      <div>{{ errors.message ?? ('error.email' | translate) }}</div>
    }

    @if (errors.pattern) {
      <div>{{ errors.message ?? ('error.pattern' | translate) }}</div>
    }

    @if (errors.dateNotGreaterOrEqual) {
      <div>{{ errors.message ?? ('error.datenotgreaterorequal' | translate: { date: (errors.dateNotGreaterOrEqual.requiredDate | date: DATE_FORMAT) }) }}</div>
    }

    @if (errors.dateNotLessOrEqual) {
      <div>{{ errors.message ?? ('error.datenotlessorequal' | translate: { date: (errors.dateNotLessOrEqual.requiredDate | date: DATE_FORMAT) }) }}</div>
    }

    @if (errors.lengthEqualTo) {
      <div>{{ errors.message ?? ('error.lengthEqualTo' | translate) }}</div>
    }

    @if (errors.dateRangeExceeded) {
      <div>{{ (errors.message ?? 'error.dateRangeExceeded' | translate: { maxDays: errors.dateRangeExceeded.maxDays }) | replace: 'maxDays' : errors.dateRangeExceeded.maxDays }}</div>
    }

    @if (errors.dateRangeTooShort) {
      <div>{{ (errors.message ?? 'error.dateRangeTooShort' | translate: { minDays: errors.dateRangeTooShort.minDays }) | replace: 'minDays' : errors.dateRangeTooShort.minDays }}</div>
    }

    @if (errors.dateRangeMonthsExceeded) {
      <div>{{ (errors.message ?? 'error.dateRangeMonthsExceeded' | translate: { maxMonths: errors.dateRangeMonthsExceeded.maxMonths }) | replace: 'maxMonths' : errors.dateRangeMonthsExceeded.maxMonths }}</div>
    }
  </div>
}
